import React from 'react';
import { createRoot } from 'react-dom/client';
import "./styles/styles.scss";
import { AppRoutes } from './routes/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './common/ErrorBoundary';

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter> {/* Envuelve tu aplicación con BrowserRouter */}
      < AppRoutes/>
      </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );

